import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('my-modal', {
    staticClass: "warehouse-importer-add-edit-modal",
    attrs: {
      "data-sign": "commodity_importer_add_edit_modal",
      "width": 800,
      "title": _vm.cvId ? _vm.isCopy ? _vm.t('复制进口商') : _vm.t('编辑进口商') : _vm.t('新增进口商')
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('a-form-model', {
    ref: "formDataRef",
    attrs: {
      "data-sign": "commodity_importer_add_edit_form",
      "rules": _vm.formDataRule,
      "model": _vm.formData
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "fbu-analyse-name": $t("\u4ED3\u5E93"),
      "prop": "warehouse_code",
      "label": _vm.t('仓库')
    }
  }, [_c('my-select', {
    staticClass: "form-item-select",
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "placeholder": _vm.t('请选择仓库')
    },
    on: {
      "change": _vm.handleChangeWarehouse
    },
    model: {
      value: _vm.formData.warehouse_code,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "warehouse_code", $$v);
      },
      expression: "formData.warehouse_code"
    }
  }, _vm._l(_vm.warehouseList, function (item) {
    return _c('a-select-option', {
      key: item.warehouse_code,
      attrs: {
        "value": item.warehouse_code
      }
    }, [_vm._v(" " + _vm._s(item.warehouse_name_text) + " ")]);
  }), 1)], 1), _vm._l(_vm.filedConfigList, function (item) {
    return _c('a-form-model-item', {
      key: item.filed,
      attrs: {
        "prop": item.key_option_list && item.key_option_list.length ? item.filed + ".value" : item.filed
      }
    }, [_c('label', {
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [item.key_option_list && item.key_option_list.length ? _c('my-select', {
      staticStyle: {
        "width": "150px"
      },
      attrs: {
        "allowClear": false
      },
      model: {
        value: _vm.formData[item.filed].code,
        callback: function ($$v) {
          _vm.$set(_vm.formData[item.filed], "code", $$v);
        },
        expression: "formData[item.filed].code"
      }
    }, _vm._l(item.key_option_list, function (option) {
      return _c('a-select-option', {
        key: option.code,
        attrs: {
          "value": option.code
        }
      }, [_vm._v(" " + _vm._s(option.value) + " ")]);
    }), 1) : _c('span', [_vm._v(_vm._s(item.value))]), item.word_desc ? _c('a-tooltip', {
      attrs: {
        "placement": "top",
        "title": _vm.t(item.word_desc)
      }
    }, [_c('a-icon', {
      staticClass: "ml-5",
      staticStyle: {
        "vertical-align": "middle"
      },
      attrs: {
        "type": "question-circle"
      }
    })], 1) : _vm._e()], 1), item.key_option_list && item.key_option_list.length ? _c(_vm.formControlMap[item.value_type], {
      tag: "components",
      attrs: {
        "ext-list": _vm.getExtList(item.attach_type_list),
        "max-length": item.word_limit,
        "attachment-url": item.attach_url,
        "option-list": item.value_drop_option_list,
        "multiple": item.value_type === _vm.$enum.warehouse.ImporterFormControlType.SELECT_MULTIPLE
      },
      on: {
        "validate": function ($event) {
          return _vm.handleValidateField(item.filed);
        }
      },
      model: {
        value: _vm.formData[item.filed].value,
        callback: function ($$v) {
          _vm.$set(_vm.formData[item.filed], "value", $$v);
        },
        expression: "formData[item.filed].value"
      }
    }) : _c(_vm.formControlMap[item.value_type], {
      tag: "components",
      attrs: {
        "ext-list": _vm.getExtList(item.attach_type_list),
        "max-length": item.word_limit,
        "attachment-url": item.attach_url,
        "content": item.statement_desc,
        "option-list": item.value_drop_option_list,
        "multiple": item.value_type === _vm.$enum.warehouse.ImporterFormControlType.SELECT_MULTIPLE
      },
      on: {
        "validate": function ($event) {
          return _vm.handleValidateField(item.filed);
        }
      },
      model: {
        value: _vm.formData[item.filed],
        callback: function ($$v) {
          _vm.$set(_vm.formData, item.filed, $$v);
        },
        expression: "formData[item.filed]"
      }
    })], 1);
  })], 2), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('a-button', {
    attrs: {
      "data-sign": "commodity_importer_add_edit_cancel",
      "data-permission": "commodity_importer_add_edit_cancel",
      "id": "commodity_importer_add_edit_cancel",
      "fbu-analyse-name": $t("\u53D6\u6D88")
    },
    on: {
      "click": function ($event) {
        _vm.visible = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.t('取消')))]), _c('a-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading,
      "data-permission": "commodity_importer_add_edit_submit",
      "id": "commodity_importer_add_edit_submit",
      "data-sign": "commodity_importer_add_edit_submit",
      "fbu-analyse-name": $t("\u786E\u8BA4")
    },
    on: {
      "click": _vm.handleOk
    }
  }, [_vm._v(_vm._s(_vm.t('确认')))])], 1)], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };